<template>
  <div>
    <div @click="generateReport()" class="btn">Obtenir les résultats sous forme de PDF</div>
       <vue3-html2pdf
        :show-layout="false"
        :enable-download="true"
        :preview-modal="false"
        :manual-pagination="true"
        filename="Résultats du quiz"
        pdf-format="a4"
        pdf-orientation="portrait"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
        <template v-slot:pdf-content>
          <!-- Supprimer le div wrapper avec margin -->
          <div id="pdf-results">
            
            <!-- En-tête immédiat -->
            <div class="pdf-header">
              <img src="@/assets/pdf/header-pdf.jpg" alt="">
            </div>
            
            <!-- Contenu principal immédiat -->
            <div class="pdf-body">
              <section class="titre">
                <h1>Mes résultats</h1>
              </section>
              <section class="content">
                <div class="pdf-jobsList">
                  <ul>
                    <li class="job" v-for="(result, index) in results" :key="`result-${index}`"
                        :style="{color:percentageColor(result.percentage)}"
                    >
                      <div class="count">{{ index+1 }}. </div>
                      <span class="job-title">
                        {{ jobs[result.jobIndex].metier }} <br><span v-if="jobs[result.jobIndex].metier_fr">({{ jobs[result.jobIndex].metier_fr }})</span>
                      </span>
                      <!-- <span class="percentage">{{ result.percentage }}%</span> -->
                    </li>
                  </ul>
                </div>
              </section>
            </div>

            <!-- Footer -->
            <div class="pdf-footer">
              <img src="@/assets/pdf/footer-pdf.jpg" alt="">
            </div>
          </div>
        </template>
    </vue3-html2pdf>
  </div>
</template>

<script>
import Vue3Html2pdf from 'vue3-html2pdf'

export default {
  name: 'printPdfButton',
  components: {
    Vue3Html2pdf
  },

  methods: {
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },
    onProgress (progress) {
      console.log('PDF Progress:', progress)
    },
    hasStartedGeneration () {
      console.log('PDF generation started')
    },
    hasGenerated (blobPdf) {
      console.log('PDF generated:', blobPdf)
    },
    percentageColor ($percentage) {
      let color = 'black'
      if ($percentage >= 95) {
        color = 'green'
      } else if ($percentage >= 85 && $percentage < 95) {
        color = 'YellowGreen'
      } else if ($percentage >= 80 && $percentage < 85) {
        color = 'GoldenRod'
      } else if ($percentage >= 0 && $percentage < 70) {
        color = 'Tomato'
      }
      return color
    }
  },

  computed: {
    jobs () {
      return this.$store.state.jobs
    },
    userResponses () {
      return this.$store.state.userResponses
    },
    results () {
      return this.$store.state.results
    }
  }
}
// https://codesandbox.io/s/gautamkabiraj96-vuejs-html-to-pdf-generate-example-6bgmf?file=/src/App.vue:32-93
</script>

<style lang="scss">
  #pdf-results {
    background-color: #fff;
    font-family: Arial, sans-serif;
    width: 100%;
    margin: 0;
    padding: 0;

    // En-tête simple
    .pdf-header {
      width: 100%;
      height: auto;

      img {
        width: 100%;
        height: auto;
        display: block;
        margin: 0;
      }
    }

    // Contenu principal
    .pdf-body {
      padding: 0 40px;
      min-height: 200px;

      .titre {
        text-align: center;
         page-break-after: avoid;
        
        h1 {
          font-size: 28px;
          color: #000;
          margin: 0;
          padding: 20px 0;
        }
      }

      .content {
        .pdf-jobsList {
          ul {
            list-style: none;
            margin: 0;
            padding: 0;

            li.job {
              font-size: 12px;
              line-height: 1.8;
              margin-bottom: 2px;
              page-break-inside: avoid;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 2px 0;
              border-bottom: 1px dotted #c8c8c8;

              .count {
                font-weight: bold;
                min-width: 30px;
              }

              .job-title {
                flex: 1;
                padding: 0 15px;
                text-align: left;
                line-height: 1.1;
              }

              .percentage {
                font-weight: bold;
                min-width: 60px;
                text-align: right;
              }
            }
          }
        }
      }
    }

    // Footer simple
    .pdf-footer {
      width: 100%;
      height: auto;
      margin-top: 30px; // Espacement avec le contenu
      page-break-inside: avoid; 

      img {
        width: 100%;
        height: auto;
        display: block;
        margin: 0;
      }
    }
  }
</style>